var _circle, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpera3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 3018,
    height: 3018,
    viewBox: "0 0 3018 3018",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_245_70700)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#paint0_angular_245_70700_clip_path)",
    "data-figma-skip-parse": "true"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.71293 0.71293 -0.71293 0.71293 1508.86 1508.86)"
  }, /*#__PURE__*/React.createElement("foreignObject", {
    x: -1000.99,
    y: -1000.99,
    width: 2001.98,
    height: 2001.98
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      background: "conic-gradient(from 90deg,rgba(217, 217, 217, 1) 0deg,rgba(0, 101, 255, 1) 0.036deg,rgba(255, 0, 0, 1) 78.75deg,rgba(13, 167, 255, 1) 187.5deg,rgba(0, 53, 242, 1) 268.125deg,rgba(255, 161, 161, 1) 360deg)",
      height: "100%",
      width: "100%",
      opacity: 0.1
    }
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 1508.86,
    cy: 1508.86,
    r: 1008.24,
    transform: "rotate(-45 1508.86 1508.86)",
    "data-figma-gradient-fill": "{\"type\":\"GRADIENT_ANGULAR\",\"stops\":[{\"color\":{\"r\":0.85098040103912354,\"g\":0.85098040103912354,\"b\":0.85098040103912354,\"a\":1.0},\"position\":0.0},{\"color\":{\"r\":0.0,\"g\":0.39999991655349731,\"b\":1.0,\"a\":1.0},\"position\":9.9999997473787516e-05},{\"color\":{\"r\":1.0,\"g\":0.0,\"b\":0.0,\"a\":1.0},\"position\":0.218750},{\"color\":{\"r\":0.0510253906250,\"g\":0.65836918354034424,\"b\":1.0,\"a\":1.0},\"position\":0.52083331346511841},{\"color\":{\"r\":0.0,\"g\":0.20889973640441895,\"b\":0.94954425096511841,\"a\":1.0},\"position\":0.74479168653488159},{\"color\":{\"r\":1.0,\"g\":0.63333332538604736,\"b\":0.63333332538604736,\"a\":1.0},\"position\":1.0}],\"stopsVar\":[],\"transform\":{\"m00\":1425.8602294921875,\"m01\":-1425.8602294921875,\"m02\":1508.8602294921875,\"m10\":1425.8602294921875,\"m11\":1425.8602294921875,\"m12\":83.000091552734375},\"opacity\":0.10000000149011612,\"blendMode\":\"NORMAL\",\"visible\":true}"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_245_70700",
    x: 0.625,
    y: 0.625,
    width: 3016.47,
    height: 3016.47,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 250,
    result: "effect1_foregroundBlur_245_70700"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "paint0_angular_245_70700_clip_path"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1508.86,
    cy: 1508.86,
    r: 1008.24,
    transform: "rotate(-45 1508.86 1508.86)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpera3);
export default __webpack_public_path__ + "static/media/spera3.2713f7de2bf07c1c66ea40904b1bba15.svg";
export { ForwardRef as ReactComponent };